export const defaultDocsDetails = {
  DocumentType: '',
  Language: '',
  ContractType: '',
  State: '',
  CustomerType: '',
  additionalInformation: '',
  ProductName: '',
  Utility: '',
  Commodity: '',
  documentName: '',
  EContractDeliveryTime: '',
  FileUrl: null,
  Logo: ''
}

export interface Tag {
  id: number;
  x: number;
  y: number;
  page: number;
  label: string;
}
export enum eContractDeliveryTimeTypes {
  AFTER_ENROLLMENT = 'AFTER_ENROLLMENT',
  AFTER_QC_APPROVED = 'AFTER_QC_APPROVED'
}